import React, { useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import park from "../../assets/images/park.png";
import campsite from "../../assets/images/campsite.png";
import { useNavigate } from "react-router-dom";

const allowedUserIds = [
  "ZZ916584",
  "C8J1P6DR",
  "34AB56CD",
  "M2C5ZDQW",
  "ST56UV78",
  "90QR12ST",
  "34UV56WX",
  "5CAFBPYH",
  "78YZ90AB",
  "UFTBN1O1",
  "MN34OP56",
  "OP12QR34",
  "KL78MN90",
  "2D9BFUVY",
  "UV12WX34",
  "WSORODTJ",
  "REj7Rzf1",
]; // Whitelisted user IDs

function TestPage() {
  const navigate = useNavigate();
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    PlutonicuserID,
    setCurrentFormType,
    loading, // ✅ new
  } = useContext(AuthContext);

  useEffect(() => {
    if (loading) return; // ✅ Wait until context is fully loaded

    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    console.log("[TestPage] Current User ID:", userId);

    if (!allowedUserIds.includes(userId)) {
      console.warn(`[TestPage] User ID (${userId}) is not allowed to access this page.`);
      navigate("/therapy-rooms");
    }
  }, [loading, PlutonicuserID, navigate]);

  if (loading) {
    // ✅ Optionally show loader to avoid flicker
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  const rooms = [
    {
      id: "test-park-therapy",
      title: "Test Park Therapy Room",
      description: "Testing room for the park.",
      image: park,
      style: "Green Space",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-beach-therapy",
      title: "Test Beach Therapy Room",
      description: "Testing room for the beach.",
      image: beach,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-forest-therapy",
      title: "Test forest Therapy Room",
      description: "Testing room for the forest.",
      image: forest,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
    {
      id: "test-campsite-therapy",
      title: "Test campsite Therapy Room",
      description: "Testing room for the campsite.",
      image: campsite,
      style: "Modern Design",
      accessibility: "PC Web Browser | Chrome, Edge",
      available: true,
      sessionStartTimeEST: "Always Available",
      online: false,
    },
  ];

  const handleEnterClick = (roomType) => {
    const userId = PlutonicuserID ;
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }

    const testMeetingID = `${roomType}-fixed-meeting-id`;
    sessionStorage.setItem("meetingID", testMeetingID);
    sessionStorage.setItem("userId", userId);

    console.log(
      "[TestPage] sessionStorage - meetingID:",
      sessionStorage.getItem("meetingID")
    );
    console.log(
      "[TestPage] sessionStorage - userId:",
      sessionStorage.getItem("userId")
    );

    const realRoomType = roomType.replace("test-", "");
    navigate(`/unity-room/${realRoomType}`);
  };

  return (
    <div>
      <Navbar
      />
      <div
        className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
          background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
        }}
      >
        <h2 className="text-3xl font-bold mb-12 self-start pl-4 mt-8">
          Your Virtual Spaces
        </h2>
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
          {rooms.map((room) => (
            <TherapyRoomCard
              key={room.id}
              room={{
                id: room.id,
                image: room.image,
                title: room.title,
                style: room.style,
                description: room.description,
                accessibility: room.accessibility,
                available: room.available,
                sessionStartTimeEST: room.sessionStartTimeEST,
                online: room.online,
              }}
              onEnterClick={() => handleEnterClick(room.id)}
              sessions={[
                {
                  meetingID: `${room.id}-fixed-id`,
                  sessionStartTimeEST: "Always Available",
                  isAvailable: true,
                  isUpcoming: false,
                  isPrimary: true,
                  sessionStartTimeUTC: new Date().toISOString(),
                },
              ]}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TestPage;
